module.exports = __webpack_public_path__ + "static/media/james-boru.140cf054.png";